module.exports = __webpack_public_path__ + "static/media/projektanci.60064e2d.jpg";